import Vue from 'vue';
import { DeviceUUID } from 'device-uuid';
export const loginService = {
    login,
    logout,
    displayLogin,
    validateMFACode,
    resendCode,
};

const headersParam = {
    "Accept": "*/*",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
};

function login(username, password) {
    let url = "/login/processlogin";
    let user = JSON.parse(localStorage.getItem("user"));
    let deviceId = getDeviceId();

    return Vue.prototype.$axios.post(url, {
        UserName: username,
        Password: password,
        LockedOut: user?.LockedOut ? new Date(parseInt(user.lockedOut.substr(6))) : null,
        RejectedPassword: user ? user.rejectedPassword : 0,
        DeviceId: deviceId
    }, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success) {
                localStorage.setItem("user", JSON.stringify(response.data.user));
                return response.data;
            }
            else {
                if (JSON.stringify(response.data.user)) {
                    localStorage.setItem("user", JSON.stringify(response.data.user));
                }

                throw new Error(response.data.error)
            }
        });
}

function displayLogin() {
    let url = "/login/displaylogin";

    return Vue.prototype.$axios.get(url, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success) {
                return response.data;
            }
        })
        .catch(() => {
            return false;
        });
}

function logout() {
    let url = "/login/logout";

    return Vue.prototype.$axios.get(url, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success) {
                localStorage.removeItem("user");
            }
            return response;
        });
}

function validateMFACode(auditRoot, mfaCode, userId) {
    let url = "/login/mfacodevalidation";
    let deviceId = getDeviceId();

    return Vue.prototype.$axios.post(url, { AuditRoot: auditRoot, MFACode: mfaCode, UserId: userId, DeviceId: deviceId }, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success) {
                localStorage.setItem("user", JSON.stringify(response.data.user));
                return response.data.user;
            }
            else
                throw new Error(response.data.error);
        });
}

function resendCode(auditRoot, userId, mfaType) {
    let url = "/login/sendmfacode";
    let deviceId = getDeviceId();

    return Vue.prototype.$axios.post(url, { AuditRoot: auditRoot, UserId: userId, DeviceId: deviceId, MFAType: mfaType }, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success) {
                return response;
            }
            else
                throw new Error(response.data.error);
        });
}

function getDeviceId() {
    let du = new DeviceUUID().parse();
    let dua = [
        du.language,
        du.platform,
        du.os,
        du.cpuCores,
        du.isAuthoritative,
        du.silkAccelerated,
        du.isKindleFire,
        du.isDesktop,
        du.isMobile,
        du.isTablet,
        du.isWindows,
        du.isLinux,
        du.isLinux64,
        du.isMac,
        du.isiPad,
        du.isiPhone,
        du.isiPod,
        du.isSmartTV,
        du.pixelDepth,
        du.isTouchScreen
    ];
    return du.hashMD5(dua.join(':'));
}

function handleResponse(response) {
    if (!response.data) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            logout();
            location.reload(true);
        }

        const error = (response.data && response.data.error) || response.statusText;
        return Promise.reject(error);
    }

    return response;

}